/**
 * Capability matcher — TS mirror of the backend's
 * `app.core.rbac.matcher.has_capability`. A held capability set may contain
 * exact caps, the global wildcard "*", namespace wildcards ("surface:*"), or
 * prefix globs ("tool:marq_*"). Returns whether `needed` is granted.
 */
export function hasCapability(held: readonly string[], needed: string): boolean {
  if (held.includes("*")) return true;
  return held.some((cap) => {
    if (cap === needed) return true;
    if (cap.endsWith("*")) return needed.startsWith(cap.slice(0, -1));
    return false;
  });
}
